import React from 'react';
import { useIntl } from 'react-intl';
import Select from 'react-select';

export default ({ name, label, options, filters, onSelect, getOptionLabel, ...props }) => {
  const { formatMessage } = useIntl();

  return <div className={`filter filter-${name} d-inline-block`}>
    <Select
      name={name}
      placeholder={label}
      value={[filters[name]]}
      isSearchable={false}
      isClearable
      options={options}
      getOptionLabel={getOptionLabel || (value => value)}
      getOptionValue={value => value}
      isOptionSelected={(option, [value]) => option === value}
      onChange={(option, meta) => onSelect(option && option, meta)}
      noOptionsMessage={() => formatMessage({ id: 'common.lang.no.options' })}
      {...props}
    />
  </div>
}
